import { IAddon, IAnyPlan } from '@belong/types';

const NBN_PRODUCT_DEFAULT = {
  PRICE_UNIT: '$',
  CHARGE_TYPE: 'Month',
  NETWORK_SPEED_UNIT: 'Mbps',
  DESCRIPTION: 'nbn product'
};

const FAddon = (data): IAddon => {
  const {
    productCode,
    productId,
    productName,
    description,
    priceValue,
    priceUnit,
    priceFrequency,
    chargeType,
    included
  } = data.fields;

  const price = {
    unit: priceUnit,
    value: priceValue,
    recurringFrequency: priceFrequency,
    chargeType
  };

  return {
    productCode,
    productId,
    productName,
    description,
    price,
    included
  };
};

const FNbnProduct = (nbnProduct): IAnyPlan => {
  const { categoryName, frequency, price, productCode, planProductCode, ...otherFields } = nbnProduct.fields;

  const result = {
    chargeType: frequency,
    description: NBN_PRODUCT_DEFAULT.DESCRIPTION,
    priceFrequency: NBN_PRODUCT_DEFAULT.CHARGE_TYPE,
    priceUnit: NBN_PRODUCT_DEFAULT.PRICE_UNIT,
    priceValue: price,
    productId: productCode,
    productCode: planProductCode,
    productType: categoryName,
    ...otherFields
  };

  return result;
};

export const FProduct = (product): IAnyPlan => {
  const isNbnProduct = !product.fields.productId;
  const {
    addons,
    chargeType,
    dataUnit,
    dataValue,
    eveningUpstreamSpeedMbps,
    eveningDownstreamSpeedMbps,
    description,
    included,
    priceFrequency,
    priceUnit,
    priceValue,
    productCode,
    productId,
    productName,
    productType,
    ...otherFields
  } = isNbnProduct ? FNbnProduct(product) : product.fields;

  const price = {
    value: priceValue,
    unit: priceUnit,
    recurringFrequency: priceFrequency,
    chargeType
  };

  const result: IAnyPlan = {
    productCode,
    productId,
    productName,
    description,
    data: dataUnit &&
      dataValue && {
        unit: dataUnit,
        value: dataValue
      },
    networkSpeed: eveningUpstreamSpeedMbps &&
      eveningDownstreamSpeedMbps && {
        upstream: {
          unit: NBN_PRODUCT_DEFAULT.NETWORK_SPEED_UNIT,
          value: eveningUpstreamSpeedMbps
        },
        downstream: {
          unit: NBN_PRODUCT_DEFAULT.NETWORK_SPEED_UNIT,
          value: eveningDownstreamSpeedMbps
        }
      },
    price,
    addons: (addons || []).map(addon => FAddon(addon)),
    ...otherFields
  };

  return result;
};
